import { closeNav } from './navigation.js';

// ============================================================
// Modal – Trigger via data-modal="<dialog-id>"
// Schließen via data-modal="close" oder Klick auf Backdrop
// ============================================================

const body = document.body;

// Fokus-Falle: alle fokussierbaren Elemente im Dialog
const FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
].join(', ');

// ── Hilfsfunktionen ──────────────────────────────────────────

/**
 * Fokus-Trap: Tab/Shift+Tab bleibt innerhalb des Dialogs
 */
const trapFocus = (dialog, event) => {
    const focusable = [...dialog.querySelectorAll(FOCUSABLE)];
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.key === 'Tab') {
        if (event.shiftKey) {
            if (document.activeElement === first) {
                event.preventDefault();
                last.focus();
            }
        } else {
            if (document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    }
};

/**
 * Modal schließen mit Closing-Animation
 */
const closeModal = (dialog, previousFocus) => {
    dialog.setAttribute('closing', '');

    dialog.addEventListener(
        'animationend',
        () => {
            dialog.removeAttribute('closing');
            dialog.close();
            body.classList.remove('modal-open');

            // Fokus zum auslösenden Element zurücksetzen (A11y)
            if (previousFocus && previousFocus.focus) {
                previousFocus.focus();
            }
        },
        { once: true }
    );
};

// ── Modals initialisieren ────────────────────────────────────

document.querySelectorAll('.modal-custom').forEach((dialog) => {
    // Schließen-Button
    const closeBtn = dialog.querySelector("[data-modal='close']");
    let previousFocus = null;
    let focusTrapHandler = null;

    const open = (triggerEl) => {
        // Navigation schließen, falls geöffnet
        closeNav();

        // Vorherigen Fokus merken
        previousFocus = triggerEl || document.activeElement;

        // Modal öffnen
        dialog.showModal();
        body.classList.add('modal-open');

        // Scroll ans Top
        const modalBody = dialog.querySelector('.modal-custom-body');
        if (modalBody) modalBody.scrollTop = 0;

        // Ersten fokussierbaren Element fokussieren
        const firstFocusable = dialog.querySelector(FOCUSABLE);
        if (firstFocusable) {
            firstFocusable.focus();
        } else {
            dialog.focus();
        }

        // Fokus-Trap registrieren
        focusTrapHandler = (e) => trapFocus(dialog, e);
        dialog.addEventListener('keydown', focusTrapHandler);
    };

    const close = () => {
        // Fokus-Trap entfernen
        if (focusTrapHandler) {
            dialog.removeEventListener('keydown', focusTrapHandler);
            focusTrapHandler = null;
        }
        closeModal(dialog, previousFocus);
    };

    // Schließen-Button
    if (closeBtn) {
        closeBtn.addEventListener('click', close);
    }

    // Escape-Key (nativer dialog-Event)
    dialog.addEventListener('cancel', (e) => {
        e.preventDefault(); // eigene Animation übernehmen
        close();
    });

    // Klick auf Backdrop – dialog-Element selbst (nativer ::backdrop)
    dialog.addEventListener('click', (e) => {
        if (e.target === dialog) {
            close();
        }
    });

    // Klick auf modal-custom-body außerhalb des Containers (visueller Backdrop)
    const modalBody = dialog.querySelector('.modal-custom-body');
    if (modalBody) {
        modalBody.addEventListener('click', (e) => {
            if (e.target === modalBody) {
                close();
            }
        });
    }

    // open() für Trigger-Buttons verfügbar machen
    dialog._openModal = open;
});

// ── Trigger-Buttons ─────────────────────────────────────────

document.querySelectorAll('[data-modal]').forEach((trigger) => {
    const value = trigger.dataset.modal;

    // "close" ist für interne Schließen-Buttons – überspringen
    if (value === 'close') return;

    const dialog = document.getElementById(value);
    if (!dialog) return;

    trigger.addEventListener('click', () => {
        // Optionalen Content befüllen (z.B. Konzept-Modal)
        const content = trigger.dataset.content;
        const contentTarget = dialog.querySelector('#concept-content');
        if (content && contentTarget) {
            contentTarget.innerHTML = content;
        }

        if (dialog._openModal) {
            dialog._openModal(trigger);
        }
    });
});
